






















import { Vue, Component, Prop } from 'vue-property-decorator';
import { Mall } from 'supporter';
import { getLocalStorageMalls } from '@/utils/commonUtils';


@Component
export default class MallTab extends Vue {
  @Prop({ required: false, default: true })
  private readonly routerReloadOption: boolean;
  @Prop({ required: false })
  private readonly beforeQueryPushValidation: () => boolean;
  private mallInfo: Mall[] = getLocalStorageMalls();
  private mallIsShow: boolean = true; // 是否展示mallTab

  private btnClick(pattern: string) {
    let mallNoArray: number[] = [];
    this.mallInfo.map(mall => {
      mallNoArray.push(mall.mallNo);
    });
    let idx = mallNoArray.indexOf(Number(this.$route.query.mallNo));
    if (pattern === 'prev') {
      if (idx > 0) {
        idx = idx - 1;
      } else {
        idx = this.mallInfo.length - 1;
      }
    }
    if (pattern === 'next') {
      if (idx < this.mallInfo.length - 1) {
        idx = idx + 1;
      } else {
        idx = 0;
      }
    }

    this.pushMallNoQuery(this.mallInfo[idx].mallNo.toString());
    this.emitMallNo(this.mallInfo[idx].mallNo);
  }

  private emitMallNo(mallNo: number) {
    this.$emit('fireByMallNo', mallNo);
  }

  private onChangeRoute(event, mallNo: number): void {
    event.preventDefault();
    this.pushMallNoQuery(mallNo.toString());
    if (this.routerReloadOption) this.refresh();
  }

  private pushMallNoQuery(mallNo: string): void {
    // beforeQueryPushValidation prop 이 전달되었을때에만 실행
    if (!!this.beforeQueryPushValidation && !this.beforeQueryPushValidation()) return;

    const { query } = this.$route;

    if (query?.mallNo === mallNo) {
      this.$emit('onClickDuplicateMallNo');
      return;
    }

    this.$router.push({
      query: { mallNo: mallNo },
    });
  }

  private refresh() {
    this.$router.go(0);
  }
  private mounted() {
    if (!this.$route.query.mallNo) {
      this.$router.push({
        query: { mallNo: this.mallInfo[0].mallNo.toString() },
      });
    }

    // 判断localStorage中 mallInfo 的长度 小于等于 1 的时候隐藏
    if (this.mallInfo.length <= 1) {
      this.mallIsShow = false;
    }
  }
}
